module.exports = __webpack_public_path__ + "static/media/mobile-app.364eaf72.jpg";